import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { RechnungStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MultiSelect } from '../Select/MultiSelect';

interface RechnungStatusProps {
    disabled?: boolean;
    value: string[];
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string[]) => void;
}

export const RechnungStatusMulti: React.FC<RechnungStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        Object.keys(RechnungStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: RechnungStatusLabel[key],
            });
        });

        return list;
    }, []);

    const selectedOptions = React.useMemo(() => {
        return value.map((v) => ({
            value: v,
            label: RechnungStatusLabel[v] || v,
        }));
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <MultiSelect
                name="status"
                isDisabled={disabled}
                value={selectedOptions}
                options={options}
                onChange={(newOptions: ValueType<SelectOption, true>): void => {
                    onChange(((newOptions || []) as SelectOption[]).map((option) => option.value));
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
